import React from "react";
import { FormattedMessage as FM } from "react-intl";
import { Button, Grid } from "semantic-ui-react";

interface IEditModeControlLabelButtonsProps {
    text: string;
    onSave(): any;
    onRevertChanges(): any;
}

const EditModeControlLabelButtons: React.FC<IEditModeControlLabelButtonsProps> = (props: IEditModeControlLabelButtonsProps) => {
    const { text, onSave, onRevertChanges } = props;

    return (
        <Grid columns={2} stackable>
            <Grid.Column id="editModeText" verticalAlign="middle">
                <FM id={text} />
            </Grid.Column>
            <Grid.Column>
                <Grid columns={2}>
                    <Grid.Column>
                        <Button color="violet" fluid id="saveChanges" onClick={onSave}>
                            <FM id="profile.editModeSaveChanges" />
                        </Button>
                    </Grid.Column>
                    <Grid.Column>
                        <Button color="grey" fluid id="revertChanges" onClick={onRevertChanges} value={false}>
                            <FM id="general.cancel" />
                        </Button>
                    </Grid.Column>
                </Grid>
            </Grid.Column>
        </Grid>
    );
};

export default EditModeControlLabelButtons;
